import gql from 'graphql-tag'

export const ADD_NEW_TASKS = gql`
  mutation addTasks($data: [performance_tasks_insert_input!]!) {
    insert_performance_tasks(objects: $data) {
      affected_rows
    }
  }
`
